import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="mt-20 bg-secondary-900 text-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">黑料专区</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200">
              {siteInfo.intro}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-background-200">
                吃瓜讨论
              </span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-background-200">
                瓜友交流
              </span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-background-200">
                观点碰撞
              </span>
            </div>
          </div>

          <nav aria-label="站内导航">
            <h4 className="font-heading text-base font-semibold">站内导航</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li>
                <Link to="/" className="transition-colors hover:text-primary-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="transition-colors hover:text-primary-300">
                  话题广场
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h4 className="font-heading text-base font-semibold">话题分类</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?category=${cat.id}`}
                    className="transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} 黑料专区 · 吃瓜讨论社区 · 内容来自公开信息整理
          </p>
          <p className="flex items-center gap-2 text-xs text-background-300">
            <i className="ri-mail-line"></i>
            {siteInfo.email}
          </p>
        </div>
      </div>
    </footer>
  );
}